<template>

  <head>

    <meta charset="utf-8" />
    <title>Hotline Transporters Sacco | Create an invoice</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <link href="assets/libs/select2/css/select2.min.css" rel="stylesheet" type="text/css" />

    <link href="assets/libs/bootstrap-datepicker/css/bootstrap-datepicker.min.css" rel="stylesheet" type="text/css">
    <link href="assets/libs/spectrum-colorpicker2/spectrum.min.css" rel="stylesheet" type="text/css">
    <link href="assets/libs/bootstrap-timepicker/css/bootstrap-timepicker.min.css" rel="stylesheet" type="text/css">
    <link href="assets/libs/bootstrap-touchspin/jquery.bootstrap-touchspin.min.css" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="assets/libs/%40chenfengyuan/datepicker/datepicker.min.css">



    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />


  </head>

  <body data-sidebar="dark">



  <!-- Begin page -->
  <div id="layout-wrapper">



    <!-- ========== Left Sidebar Start ========== -->

    <NavigationBar/>


    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="main-content">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Pending Approvals</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                    <li class="breadcrumb-item"><a href="#">Employee Approvals</a></li>
                    <li class="breadcrumb-item">
                      Pending Approvals-data edits
                    </li>

                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- stats cards -->

          <!-- end of stats -->
          <div class="row">
            <div class="col-12">
              <div class="card">

                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">



                </div>
                <div class="card-body">
                  <div class="table-responsive ">
                    <!-- Table -->

                    <div>
                      <table class="table align-middle table-hover contacts-table table-striped text-nowrap" id="datatable-buttons">
                        <thead class="table-light">
                        <tr class="table-dark">
                          <th scope="col">Date</th>
                          <th scope="col">Field(s) Edited</th>
                          <th scope="col">Edited By</th>
                          <th scope="col">Edited Date</th>
                          <th scope="col">Reason for Edit</th>
                          <th scope="col">Net Salary After Edit</th>
                          <th scope="col">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in employeeDataEdits" :key="index">
                          <td>{{ formatDate(item.dateCreated) }}</td>
                          <td>{{ getFormattedChangedFields(item.previousData, item.newData) }}</td>
                          <td>{{ item.createdBy }} <span v-if="item.submittingOfficerRole">({{ item.submittingOfficerRole }})</span></td>
                          <td>{{ formatDate(item.dateCreated) }}</td>
                          <td>{{ item.reason || 'Employee data update' }}</td>
                          <td>{{ getNetSalaryAfterEdit(item.newData) }}</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="viewEditDetails(item)" data-bs-toggle="modal" data-bs-target="#editLogModal">
                              View Details
                            </button>
                          </td>
                        </tr>
                        </tbody>
                      </table>

                      <!-- Edit Log Modal -->
                      <div class="modal fade" id="editLogModal" tabindex="-1" aria-labelledby="editLogModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered modal-lg">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title" id="editLogModalLabel">Edit Log Details</h5>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body" v-if="selectedEdit">
                              <p><strong>Edited By:</strong> {{ selectedEdit.createdBy }} <span v-if="selectedEdit.submittingOfficerRole">({{ selectedEdit.submittingOfficerRole }})</span></p>
                              <p><strong>Edited Date:</strong> {{ formatDate(selectedEdit.dateCreated) }}</p>
                              <p><strong>Reason for Edit:</strong> {{ selectedEdit.reason || 'Employee data update' }}</p>
                              <p><strong>Net Salary After Edit:</strong> {{ getNetSalaryAfterEdit(selectedEdit.newData) }}</p>
                              <hr>
                              <h6>Changes:</h6>
                              <div class="table-responsive">
                                <table class="table table-bordered table-striped">
                                  <thead>
                                  <tr>
                                    <th>Field</th>
                                    <th>Previous Value</th>
                                    <th>New Value</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="field in getDetailedChanges(selectedEdit.previousData, selectedEdit.newData)" :key="field.name">
                                    <td><strong>{{ field.displayName }}</strong></td>
                                    <td class="text-danger">{{ field.previousValue || '-' }}</td>
                                    <td class="text-success">{{ field.newValue || '-' }}</td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>

                              <div class="row mt-4" v-if="selectedEdit.approved === 'false'">
                                <div class="col-md-6 mb-3">
                                  <button type="button" class="btn btn-success w-100" data-bs-toggle="modal" data-bs-target="#approveModal">
                                    <i class="bx bx-check-circle me-1"></i> Approve Changes
                                  </button>
                                </div>
                                <div class="col-md-6 mb-3">
                                  <button type="button" class="btn btn-danger w-100" @click="declineChanges(selectedEdit.id)">
                                    <i class="bx bx-x-circle me-1"></i> Decline Changes
                                  </button>
                                </div>
                              </div>
                              <div v-else class="alert alert-info">
                                <i class="bx bx-info-circle me-1"></i>
                                <span v-if="selectedEdit.approved === 'true'">
                These changes were approved by {{ selectedEdit.approvedBy }} on {{ formatDate(selectedEdit.dateApproved) }}.
              </span>
                                <span v-else-if="selectedEdit.approved === 'declined'">
                These changes were declined.
              </span>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>

          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->




      <!-- Approve Modal with OTP -->
      <div class="modal fade" id="approveModal" tabindex="-1" aria-labelledby="approveModalLabel" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content bg-light-blue border-success">
            <div class="modal-header text-black text-uppercase border-0">
              <h4 class="modal-title" id="approveModalLabel">Approve Edit Changes</h4>
              <button @click="closeAllModals()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <!-- OTP Entry Section -->
            <div v-if="alert.info" class="modal-body approve-otp-entry">
              <div class="mb-3">
                <label for="approveReason" class="form-label fw-bold">Reason for Approval</label>
                <textarea class="form-control border-success" id="approveReason" rows="3" placeholder="Please enter your reason for approving these changes..."></textarea>
              </div>

              <div class="alert alert-success border-success border-2" role="alert">
                <h4 class="alert-heading text-black text-uppercase">OTP Verification</h4>
                <p>An OTP (One-Time Password) has been sent to your phone: <strong>+254 7XX XXX 123</strong>. Please enter the OTP to verify and approve the employee record changes.</p>

                <div class="hstack gap-3">
                  <input class="form-control me-auto border-black otp-input" type="text" placeholder="Enter OTP" aria-label="Enter OTP here..." spellcheck="false">
                  <button type="button" class="btn btn-warning text-dark fw-bold text-nowrap text-uppercase">Resend OTP</button>
                </div>
              </div>

              <button @click="approveChanges(selectedEdit.id)" class="btn btn-success fw-bold mt-4 text-uppercase w-100 d-flex justify-content-center align-items-center text-center otp-btn" id="confirmApproveBtn" title="Confirm Approval">
                <div>Confirm Approval</div>
                <div class="spinner-border text-white ms-2 d-none" style="height: 19px; width: 19px;" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </button>
            </div>

            <!-- Success Message (Initially Hidden) -->
            <div v-if="alert.success" class="modal-body approve-success">
              <div class="p-4 pb-1 px-1 d-flex align-items-center justify-content-center flex-column pt-1">
                <div class="flex-shrink-0 align-self-center mb-4">
                  <div class="avatar-md rounded-circle bg-success mini-stat-icon">
                            <span class="avatar-title rounded-circle bg-success">
                                <i class="bx bx-check-circle fs-1"></i>
                            </span>
                  </div>
                </div>
                <h4 class="text-uppercase text-dark modal-title fw-bold">Changes Approved Successfully</h4>
                <p class="text-center px-5">
                  The employee record changes have been approved successfully. The system has been updated with the new information.
                </p>
                <div class="w-100 mt-2">
                  <button @click="closeAllModals()" type="button" data-dismiss="modal" aria-label="Close" class="btn btn-outline-success waves-effect w-100 btn-close-btn text-uppercase fw-bold">
                    Close
                  </button>
                </div>
              </div>
            </div>

            <!-- show this for a failed attempt -->
            <div v-if="alert.failed" class="modal-body waiver-fail">
              <div class="p-4 pb-1  px-1 d-flex align-items-center justify-content-center flex-column pt-1">
                <div class="flex-shrink-0 align-self-center mb-4">
                  <div class="avatar-md rounded-circle bg-danger mini-stat-icon" title="Recruitment Approval Failed">
                                            <span class="avatar-title rounded-circle bg-danger">
                                                <i class="mdi mdi-alert-circle fs-1" title="Recruitment Failed"></i>
                                            </span>
                  </div>
                </div>
                <h4 class="text-uppercase text-danger modal-title fw-bold" title="Recruitment Approval Failed">Recruitment Approval Failed</h4>
                <p class="text-center px-5" title="Recruitment Failure Reason">
                  Unfortunately, the approval of this recruitment record was unsuccessful. {{message}}
                </p>

                <div class="w-100 mt-2">
                  <button type="button" class="btn btn-info waves-effect w-100 btn-close-btn text-uppercase fw-bold">Retry</button>
                  <h6 class="text-center my-2">- OR -</h6>
                  <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn btn-outline-secondary waves-effect w-100 btn-close-btn text-uppercase fw-bold">Close</button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>


      <!-- Decline Modal with OTP -->
      <div class="modal fade" id="declineModal" tabindex="-1" aria-labelledby="declineModalLabel" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content bg-light-blue border-danger">
            <div class="modal-header text-black text-uppercase border-0">
              <h4 class="modal-title" id="declineModalLabel">Decline Edit Changes</h4>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <!-- OTP Entry Section -->
            <div class="modal-body decline-otp-entry">
              <div class="mb-3">
                <label for="declineReason" class="form-label fw-bold">Reason for Declining</label>
                <textarea class="form-control border-danger" id="declineReason" rows="3" placeholder="Please enter your reason for declining these changes..."></textarea>
              </div>

              <div class="alert alert-danger border-danger border-2" role="alert">
                <h4 class="alert-heading text-black text-uppercase">OTP Verification</h4>
                <p>An OTP (One-Time Password) has been sent to your phone: <strong>+254 7XX XXX 123</strong>. Please enter the OTP to verify and decline the employee record changes.</p>

                <div class="hstack gap-3">
                  <input class="form-control me-auto border-black otp-input" type="text" placeholder="Enter OTP" aria-label="Enter OTP here..." spellcheck="false">
                  <button type="button" class="btn btn-warning text-dark fw-bold text-nowrap text-uppercase">Resend OTP</button>
                </div>
              </div>

              <button class="btn btn-danger fw-bold mt-4 text-uppercase w-100 d-flex justify-content-center align-items-center text-center otp-btn" id="confirmDeclineBtn" title="Confirm Decline">
                <div>Confirm Decline</div>
                <div class="spinner-border text-white ms-2 d-none" style="height: 19px; width: 19px;" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </button>
            </div>

            <!-- Success Message (Initially Hidden) -->
            <div class="modal-body decline-success d-none">
              <div class="p-4 pb-1 px-1 d-flex align-items-center justify-content-center flex-column pt-1">
                <div class="flex-shrink-0 align-self-center mb-4">
                  <div class="avatar-md rounded-circle bg-danger mini-stat-icon">
                            <span class="avatar-title rounded-circle bg-danger">
                                <i class="bx bx-x-circle fs-1"></i>
                            </span>
                  </div>
                </div>
                <h4 class="text-uppercase text-dark modal-title fw-bold">Changes Declined Successfully</h4>
                <p class="text-center px-5">
                  The employee record changes have been declined. The original information will be retained in the system.
                </p>
                <div class="w-100 mt-2">
                  <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn btn-outline-danger waves-effect w-100 btn-close-btn text-uppercase fw-bold">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <!-- receipting modal -->
      <div class="modal fade receipting-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Food Handler Certificate Details</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-6">
                  <address>
                    <strong class="text-capitalize">Patient Details</strong><br>
                    Mrs Jane Doe<br>
                    <a href="mailto:email@mail.com">email@mail.com</a>, <a href="tel:+254704549859">0704 549 859</a><br>

                    <br>
                    Valid From 1 Mar 2022, 10:20 AM
                    <br>
                    <span class="pr-2">Valid Till 2 Mar 2023, 10:20 AM </span>
                    <span class="badge rounded-pill bg-success text-uppercase me-3">Active</span>

                  </address>
                </div>

                <div class="col-6 text-right">
                  <address>
                    <strong class="text-capitalize">Location Details</strong><br>
                    Street/Road: Mombasa Road<br>
                    Plot No.: 122202/1250<br>
                    Building: The Tower. Floor: 12. Door/Stall No.: 123<br/>
                    Subcounty: CBD. Ward: Mututu


                  </address>
                </div>

                <div class="col-12">
                  <div class="hori-timeline mt-4">
                    <div class="owl-carousel owl-theme  navs-carousel events timeline-carousel" id="timeline-carousel">
                      <div class="item event-list">
                        <div>
                          <div class="event-date">
                            <div class="text-primary mb-1">12 Sep 2023 10:09 AM</div>
                            <h5 class="mb-4">Application</h5>
                          </div>
                          <div class="event-down-icon">
                            <i class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"></i>
                          </div>

                          <div class="mt-3 px-3">
                            <p class="text-muted text-capitalize">Self Service Portal</p>
                          </div>
                        </div>
                      </div>

                      <div class="item event-list">
                        <div>
                          <div class="event-date">
                            <div class="text-primary mb-1">13 Sep 2023 10:09 AM</div>
                            <h5 class="mb-4">Lab Test</h5>
                          </div>
                          <div class="event-down-icon">
                            <i class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"></i>
                          </div>

                          <div class="mt-3 px-3 text-capitalize">
                            <p class="text-muted">Dr Mary Jane at Taifa Clinic</p>
                            <a href="PrintDocs/health-result-slip-master/health-result-slip-master/slip33.html" target="_blank" type="button" class="btn btn-link waves-effect"><i class="mdi mdi-eye-outline"></i> View Result Slip</a>
                          </div>
                        </div>
                      </div>

                      <div class="item event-list">
                        <div>
                          <div class="event-date">
                            <div class="text-primary mb-1">14 Sep 2023 12:57 PM</div>
                            <h5 class="mb-4">Approved</h5>
                          </div>
                          <div class="event-down-icon">
                            <i class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"></i>
                          </div>

                          <div class="mt-3 px-3">
                            <p class="text-muted">Mary Max</p>
                          </div>
                        </div>
                      </div>

                      <div class="item event-list">
                        <div>
                          <div class="event-date">
                            <div class="text-primary mb-1">15 Sep 2023 12:54 PM</div>
                            <h5 class="mb-4">Certification</h5>
                          </div>
                          <div class="event-down-icon">
                            <i class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"></i>
                          </div>

                          <div class="mt-3 px-3">
                            <p class="text-muted">Certifcate Issued By Kiprop Tanui</p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="col-sm-6 text-sm-end d-none">
                  <address class="mt-2 mt-sm-0">
                    <strong>Payment Method</strong><br>
                    <span class="fw-medium">MPESA</span><br>
                    Phone No. 0704 549 859<br> <br>
                    On 1 Mar 2022, 10:20 AM
                  </address>
                </div>
              </div>
              <div class="col-12">
                <div class="py-2 mt-3">
                  <h3 class="font-size-15 fw-bold">ND12368</h3>
                </div>
              </div>
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-nowrap vertical-align-middle">
                    <thead class="bg-light">
                    <tr>
                      <th>More Details</th>
                      <th class="text-end"></th>

                    </tr>
                    </thead>

                    <tbody>
                    <tr title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Serial Number</p>
                      </td>
                      <td class="">12WER345</td>

                    </tr>

                    <tr title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Owner(s)</p>
                      </td>
                      <td class="">John Doe Kamau, James Kuria Kimotho</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Profession/Occupation</p>

                      </td>
                      <td class="">Food Processing</td>

                    </tr>
                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Application Date</p>

                      </td>
                      <td class="">5 Jan 2022 10:09 AM</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Date Approved</p>

                      </td>
                      <td class="">11 Jan 2022 09:54 AM</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Days To Expiry</p>

                      </td>
                      <td class="">134 Days</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Amount Paid</p>

                      </td>
                      <td class="text-uppercase">KES 1,000</td>

                    </tr>




                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer">

              <a href="PrintDocs/Food-handler/health-permit.html" target="_blank" type="button" class="btn btn-primary waves-effect waves-light">
                <i class="mdi mdi-printer font-size-16 align-middle me-2"></i> Print Certificate
              </a>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- end of receipting modal -->

      <!-- invoice details -->
      <div class="modal fade invoice-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Invoice Details</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="col-12">
                <address>
                  <strong>Billed To:</strong><br>
                  Kelvin Njuguna<br>
                  email@mail.com, 0704 549 859<br>
                  Hse No. 410, 90 Degrees By Tsavo
                  <br><br>
                  1 Mar 2022, 10:20 AM
                </address>
              </div>
              <div class="col-12">
                <div class="py-2 mt-3">
                  <h3 class="font-size-15 fw-bold">Invoice Details ( <span class="text-primary fw-medium">No. 1237</span> )</h3>
                </div>
              </div>
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-nowrap">
                    <thead>
                    <tr>
                      <th style="width: 70px;">No.</th>
                      <th>Item</th>
                      <th class="text-end">Amount</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>01</td>
                      <td>Rent Deposit</td>
                      <td class="text-end">KES 24,500</td>
                    </tr>

                    <tr>
                      <td>02</td>
                      <td>Monthly Rent</td>
                      <td class="text-end">KES 12,000</td>
                    </tr>

                    <tr>
                      <td>03</td>
                      <td>TAX (18%)</td>
                      <td class="text-end">KES 250</td>
                    </tr>
                    <tr>
                      <td colspan="2" class="text-end">Total</td>
                      <td class="text-end fw-bold">KES 36,750</td>
                    </tr>
                    <tr>
                      <td colspan="2" class="text-end">Paid</td>
                      <td class="text-end  fw-bold">KES 0.00</td>
                    </tr>

                    <tr>
                      <td colspan="2" class="border-0 text-end">
                        <strong>Balance</strong></td>
                      <td class="border-0 text-end">
                        <h5 class="m-0 text-uppercase fw-bold">KES 36,750</h5>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="col-12 d-none">
                <div class="table-resposive p-4 px-2 pt-2 overflow-visible">
                  <table class="w-100">
                    <tbody>
                    <tr data-id="1">
                      <td>
                        <label for="" class="">Payment Method</label>
                        <select class="form-control selectpicker w-100 payment-method" data-style="btn-secondary w-100" data-live-search="true" title="Select payment Method">
                          <option value="Mpesa">MPESA</option>
                          <option value="Cash">CASH</option>
                        </select>
                      </td>
                      <td class="px-3 ">
                        <div class="phone-num d-none">
                          <label for="">Phone No.</label>
                          <input type="text " class="form-control w-100 d-flex " placeholder="Phone No." spellcheck="false" data-ms-editor="true">
                        </div>

                      </td>
                      <td class="px-3">
                        <label for="">Amount To Be Paid</label>
                        <input type="text " class="form-control w-100 d-flex" placeholder="KES" spellcheck="false" data-ms-editor="true">

                      </td>
                      <td class="text-right float-right">
                        <div class="d-flex flex-column">
                          <label class="opacity-0">Something</label>
                          <a href="#" class="btn btn-primary w-md waves-effect waves-light">Submit</a>
                        </div>
                      </td>


                    </tr>
                    </tbody>
                  </table>

                </div>
              </div>
              <div class="float-end">
                <a href="javascript:window.print()" class="btn btn-success waves-effect waves-light me-1"><i class="mdi mdi-printer font-16px"></i></a>
                <a href="javascript: void(0);" class="btn btn-primary w-md waves-effect waves-light">Receive Payment</a>
              </div>
            </div>

          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- invoice details -->

      <!-- patients details modal -->
      <div class="modal fade patient-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">More Details On Jane</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-6">
                  <address>
                    <strong class="text-capitalize">Patient Details</strong><br>
                    Mrs Jane Doe<br>
                    <a href="mailto:email@mail.com">email@mail.com</a>, <a href="tel:+254704549859">0704 549 859</a><br>

                    <br>
                    Registered on 1 Mar 2022, 10:20 AM <br>At Sipital Kuu Medical Center
                    <br>
                    <br>
                    <span class="pr-2">Last Seen: 10    Mar 20233. 03:46 PM</span>
                    <span class="badge rounded-pill bg-success text-uppercase me-3 d-none">Active</span>

                  </address>
                </div>

                <div class="col-6 text-right">
                  <address>
                    <strong class="text-capitalize">Location Details</strong><br>
                    County: Busia, Sub County: Funyula, Ward: Marachi West,
                    <br>
                    Physical Address: Near Karachi West Primary School


                  </address>
                </div>

                <div class="col-sm-6 text-sm-end d-none">
                  <address class="mt-2 mt-sm-0">
                    <strong>Payment Method</strong><br>
                    <span class="fw-medium">MPESA</span><br>
                    Phone No. 0704 549 859<br> <br>
                    On 1 Mar 2022, 10:20 AM
                  </address>
                </div>
              </div>
              <div class="col-12">
                <div class="py-2 mt-3">
                  <h3 class="font-size-15 fw-bold">ND12368</h3>
                </div>
              </div>
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-nowrap vertical-align-middle">
                    <thead class="bg-light">
                    <tr>
                      <th>More Details</th>
                      <th class="text-end"></th>

                    </tr>
                    </thead>

                    <tbody>
                    <tr title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Patient ID</p>
                      </td>
                      <td class="">MPI/1234</td>

                    </tr>

                    <tr title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Blood Group</p>
                      </td>
                      <td class="">A+</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Age</p>

                      </td>
                      <td class="">22 Years</td>

                    </tr>
                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Marital Status</p>

                      </td>
                      <td class="">Single</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Occupation</p>

                      </td>
                      <td class="">Software Developer</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Gender</p>

                      </td>
                      <td class="">Male</td>

                    </tr>

                    <tr>
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Height</p>
                      </td>
                      <td class="">156 CM</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Weight</p>

                      </td>
                      <td class="">78 KGs</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Unpaid Bills Amount</p>

                      </td>
                      <td class="">KES 400</td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Last Updated</p>

                      </td>
                      <td class="">12 Jul 2023, 11:45 AM By Kennedy Livondo at Costa Rick Hospital</td>

                    </tr>




                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer">

              <a href="PrintDocs/Food-handler/health-permit.html" target="_blank" type="button" class="btn btn-primary waves-effect waves-light">
                <i class="mdi mdi-printer font-size-16 align-middle me-2"></i> Print Certificate
              </a>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- end of patieonts details modal -->

      <!-- kin details modal -->
      <div class="modal fade kin-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Jane's Kin Details</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-nowrap vertical-align-middle">


                    <tbody>

                    <tr title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Relationship with patient</p>
                      </td>
                      <td class="">Brother</td>

                    </tr>

                    <tr title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Full Names</p>
                      </td>
                      <td class="">Alex Kinoti Livondo</td>

                    </tr>

                    <tr title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Phone Number</p>
                      </td>
                      <td class="">
                        <a href="tel:+254712345678">0712 345 678</a>
                      </td>

                    </tr>

                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Email Address</p>

                      </td>
                      <td class=""><a href="mailto:Alex@kinoti.com">Alex@kinoti.com</a></td>

                    </tr>
                    <tr >
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Physical Address</p>

                      </td>
                      <td class="">Near Mount Kilimanjaro Joint</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer d-none">

              <a href="PrintDocs/Food-handler/health-permit.html" target="_blank" type="button" class="btn btn-primary waves-effect waves-light">
                <i class="mdi mdi-printer font-size-16 align-middle me-2"></i> Print Certificate
              </a>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- end of kin details modal -->

      <!-- Patient registration -->
      <div class="modal fade " id="registerCustomer" data-backdrop="static" data-keyboard="false" tabindex="-1 " role="dialog " aria-labelledby="staticBackdropLabel " aria-hidden="true ">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content ">


            <div class="modal-header">
              <h5 class="modal-title text-capitalize" id="exampleModalLongTitle">New Patient Registration</h5>
              <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body steps-container">
              <div class="mb-4 the-step patient-info active">
                <div class="avatar-md mx-auto mb-4 d-none">
                  <div class="avatar-title bg-light rounded-circle text-primary h1 ">
                    <i class="mdi mdi-account-multiple-plus "></i>
                  </div>
                </div>

                <div class="row  text-left">
                  <div class="col-12">
                    <h4 class="text-primary text-capitalize">Patient's Details</h4>
                    <form>
                      <div class="row ">
                        <div class="col-12 ">
                          <div class="">
                            <label for="digit1-input " class="">Patient's Full Name</label>
                          </div>
                        </div>

                        <div class="col-12 mb-3">
                          <div class="row">
                            <div class="col-4">
                              <input type="text " class="form-control two-step " placeholder="First Name">
                            </div>

                            <div class="col-4">
                              <input type="text " class="form-control two-step " placeholder="Middle Name">
                            </div>

                            <div class="col-4">
                              <input type="text " class="form-control two-step " placeholder="Last Name">
                            </div>
                          </div>
                        </div>

                        <div class="col-4 mb-3">
                          <div class="">
                            <label for="digit1-input " class="">Date Of Birth</label>
                            <input class="form-control" type="date" value="2019-08-19" id="example-date-input">
                          </div>
                        </div>
                        <div class="col-4 mb-3">
                          <div class="">
                            <label for="digit1-input " class="">Nationality</label>
                            <select class="form-control selectpicker bg-white select-revenue" data-live-search="true" title="Select a tenant">
                              <option value="">-- select one --</option>
                              <option value="afghan">Afghan</option>
                              <option value="albanian">Albanian</option>
                              <option value="algerian">Algerian</option>
                              <option value="american">American</option>
                              <option value="andorran">Andorran</option>
                              <option value="angolan">Angolan</option>
                              <option value="antiguans">Antiguans</option>
                              <option value="argentinean">Argentinean</option>
                              <option value="armenian">Armenian</option>
                              <option value="australian">Australian</option>
                              <option value="austrian">Austrian</option>
                              <option value="azerbaijani">Azerbaijani</option>
                              <option value="bahamian">Bahamian</option>
                              <option value="bahraini">Bahraini</option>
                              <option value="bangladeshi">Bangladeshi</option>
                              <option value="barbadian">Barbadian</option>
                              <option value="barbudans">Barbudans</option>
                              <option value="batswana">Batswana</option>
                              <option value="belarusian">Belarusian</option>
                              <option value="belgian">Belgian</option>
                              <option value="belizean">Belizean</option>
                              <option value="beninese">Beninese</option>
                              <option value="bhutanese">Bhutanese</option>
                              <option value="bolivian">Bolivian</option>
                              <option value="bosnian">Bosnian</option>
                              <option value="brazilian">Brazilian</option>
                              <option value="british">British</option>
                              <option value="bruneian">Bruneian</option>
                              <option value="bulgarian">Bulgarian</option>
                              <option value="burkinabe">Burkinabe</option>
                              <option value="burmese">Burmese</option>
                              <option value="burundian">Burundian</option>
                              <option value="cambodian">Cambodian</option>
                              <option value="cameroonian">Cameroonian</option>
                              <option value="canadian">Canadian</option>
                              <option value="cape verdean">Cape Verdean</option>
                              <option value="central african">Central African</option>
                              <option value="chadian">Chadian</option>
                              <option value="chilean">Chilean</option>
                              <option value="chinese">Chinese</option>
                              <option value="colombian">Colombian</option>
                              <option value="comoran">Comoran</option>
                              <option value="congolese">Congolese</option>
                              <option value="costa rican">Costa Rican</option>
                              <option value="croatian">Croatian</option>
                              <option value="cuban">Cuban</option>
                              <option value="cypriot">Cypriot</option>
                              <option value="czech">Czech</option>
                              <option value="danish">Danish</option>
                              <option value="djibouti">Djibouti</option>
                              <option value="dominican">Dominican</option>
                              <option value="dutch">Dutch</option>
                              <option value="east timorese">East Timorese</option>
                              <option value="ecuadorean">Ecuadorean</option>
                              <option value="egyptian">Egyptian</option>
                              <option value="emirian">Emirian</option>
                              <option value="equatorial guinean">Equatorial Guinean</option>
                              <option value="eritrean">Eritrean</option>
                              <option value="estonian">Estonian</option>
                              <option value="ethiopian">Ethiopian</option>
                              <option value="fijian">Fijian</option>
                              <option value="filipino">Filipino</option>
                              <option value="finnish">Finnish</option>
                              <option value="french">French</option>
                              <option value="gabonese">Gabonese</option>
                              <option value="gambian">Gambian</option>
                              <option value="georgian">Georgian</option>
                              <option value="german">German</option>
                              <option value="ghanaian">Ghanaian</option>
                              <option value="greek">Greek</option>
                              <option value="grenadian">Grenadian</option>
                              <option value="guatemalan">Guatemalan</option>
                              <option value="guinea-bissauan">Guinea-Bissauan</option>
                              <option value="guinean">Guinean</option>
                              <option value="guyanese">Guyanese</option>
                              <option value="haitian">Haitian</option>
                              <option value="herzegovinian">Herzegovinian</option>
                              <option value="honduran">Honduran</option>
                              <option value="hungarian">Hungarian</option>
                              <option value="icelander">Icelander</option>
                              <option value="indian">Indian</option>
                              <option value="indonesian">Indonesian</option>
                              <option value="iranian">Iranian</option>
                              <option value="iraqi">Iraqi</option>
                              <option value="irish">Irish</option>
                              <option value="israeli">Israeli</option>
                              <option value="italian">Italian</option>
                              <option value="ivorian">Ivorian</option>
                              <option value="jamaican">Jamaican</option>
                              <option value="japanese">Japanese</option>
                              <option value="jordanian">Jordanian</option>
                              <option value="kazakhstani">Kazakhstani</option>
                              <option value="kenyan" selected>Kenyan</option>
                              <option value="kittian and nevisian">Kittian and Nevisian</option>
                              <option value="kuwaiti">Kuwaiti</option>
                              <option value="kyrgyz">Kyrgyz</option>
                              <option value="laotian">Laotian</option>
                              <option value="latvian">Latvian</option>
                              <option value="lebanese">Lebanese</option>
                              <option value="liberian">Liberian</option>
                              <option value="libyan">Libyan</option>
                              <option value="liechtensteiner">Liechtensteiner</option>
                              <option value="lithuanian">Lithuanian</option>
                              <option value="luxembourger">Luxembourger</option>
                              <option value="macedonian">Macedonian</option>
                              <option value="malagasy">Malagasy</option>
                              <option value="malawian">Malawian</option>
                              <option value="malaysian">Malaysian</option>
                              <option value="maldivan">Maldivan</option>
                              <option value="malian">Malian</option>
                              <option value="maltese">Maltese</option>
                              <option value="marshallese">Marshallese</option>
                              <option value="mauritanian">Mauritanian</option>
                              <option value="mauritian">Mauritian</option>
                              <option value="mexican">Mexican</option>
                              <option value="micronesian">Micronesian</option>
                              <option value="moldovan">Moldovan</option>
                              <option value="monacan">Monacan</option>
                              <option value="mongolian">Mongolian</option>
                              <option value="moroccan">Moroccan</option>
                              <option value="mosotho">Mosotho</option>
                              <option value="motswana">Motswana</option>
                              <option value="mozambican">Mozambican</option>
                              <option value="namibian">Namibian</option>
                              <option value="nauruan">Nauruan</option>
                              <option value="nepalese">Nepalese</option>
                              <option value="new zealander">New Zealander</option>
                              <option value="ni-vanuatu">Ni-Vanuatu</option>
                              <option value="nicaraguan">Nicaraguan</option>
                              <option value="nigerien">Nigerien</option>
                              <option value="north korean">North Korean</option>
                              <option value="northern irish">Northern Irish</option>
                              <option value="norwegian">Norwegian</option>
                              <option value="omani">Omani</option>
                              <option value="pakistani">Pakistani</option>
                              <option value="palauan">Palauan</option>
                              <option value="panamanian">Panamanian</option>
                              <option value="papua new guinean">Papua New Guinean</option>
                              <option value="paraguayan">Paraguayan</option>
                              <option value="peruvian">Peruvian</option>
                              <option value="polish">Polish</option>
                              <option value="portuguese">Portuguese</option>
                              <option value="qatari">Qatari</option>
                              <option value="romanian">Romanian</option>
                              <option value="russian">Russian</option>
                              <option value="rwandan">Rwandan</option>
                              <option value="saint lucian">Saint Lucian</option>
                              <option value="salvadoran">Salvadoran</option>
                              <option value="samoan">Samoan</option>
                              <option value="san marinese">San Marinese</option>
                              <option value="sao tomean">Sao Tomean</option>
                              <option value="saudi">Saudi</option>
                              <option value="scottish">Scottish</option>
                              <option value="senegalese">Senegalese</option>
                              <option value="serbian">Serbian</option>
                              <option value="seychellois">Seychellois</option>
                              <option value="sierra leonean">Sierra Leonean</option>
                              <option value="singaporean">Singaporean</option>
                              <option value="slovakian">Slovakian</option>
                              <option value="slovenian">Slovenian</option>
                              <option value="solomon islander">Solomon Islander</option>
                              <option value="somali">Somali</option>
                              <option value="south african">South African</option>
                              <option value="south korean">South Korean</option>
                              <option value="spanish">Spanish</option>
                              <option value="sri lankan">Sri Lankan</option>
                              <option value="sudanese">Sudanese</option>
                              <option value="surinamer">Surinamer</option>
                              <option value="swazi">Swazi</option>
                              <option value="swedish">Swedish</option>
                              <option value="swiss">Swiss</option>
                              <option value="syrian">Syrian</option>
                              <option value="taiwanese">Taiwanese</option>
                              <option value="tajik">Tajik</option>
                              <option value="tanzanian">Tanzanian</option>
                              <option value="thai">Thai</option>
                              <option value="togolese">Togolese</option>
                              <option value="tongan">Tongan</option>
                              <option value="trinidadian or tobagonian">Trinidadian or Tobagonian</option>
                              <option value="tunisian">Tunisian</option>
                              <option value="turkish">Turkish</option>
                              <option value="tuvaluan">Tuvaluan</option>
                              <option value="ugandan">Ugandan</option>
                              <option value="ukrainian">Ukrainian</option>
                              <option value="uruguayan">Uruguayan</option>
                              <option value="uzbekistani">Uzbekistani</option>
                              <option value="venezuelan">Venezuelan</option>
                              <option value="vietnamese">Vietnamese</option>
                              <option value="welsh">Welsh</option>
                              <option value="yemenite">Yemenite</option>
                              <option value="zambian">Zambian</option>
                              <option value="zimbabwean">Zimbabwean</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-4 mb-3">
                          <div class="">
                            <label for="digit1-input " class="">Gender</label>
                            <div class="row">
                              <div class="col-auto">
                                <div class="form-check mb-3">
                                  <input class="form-check-input" type="radio" name="gender" id="radioFemale" >
                                  <label class="form-check-label" for="radioFemale">
                                    Female
                                  </label>
                                </div>
                              </div>

                              <div class="col-auto">
                                <div class="form-check mb-3">
                                  <input class="form-check-input" type="radio" name="gender" id="radioMale" >
                                  <label class="form-check-label" for="radioMale">
                                    Male
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-4 mb-3">
                          <div class="">
                            <label for="digit1-input " class="">Marital Status</label>
                            <select class="form-control selectpicker bg-white select-revenue" data-live-search="true" title="Select a tenant">
                              <option value="Single">Single</option>
                              <option value="Married">Married</option>
                              <option value="Widowed">Widowed</option>
                              <option value="Separated">Separated</option>
                              <option value="Divorced">Divorced</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-4 mb-3">
                          <div class="">
                            <label for="digit1-input " class="">Religion</label>
                            <select class="form-control selectpicker bg-white select-revenue" title="Select Religion" data-live-search="true">
                              <option value="African Traditional & Diasporic">African Traditional & Diasporic</option>
                              <option value="Agnostic">Agnostic</option>
                              <option value="Atheist">Atheist</option>
                              <option value="Baha'i">Baha'i</option>
                              <option value="Buddhism">Buddhism</option>
                              <option value="Cao Dai">Cao Dai</option>
                              <option value="Chinese traditional religion">Chinese traditional religion</option>
                              <option value="Christianity">Christianity</option>
                              <option value="Hinduism">Hinduism</option>
                              <option value="Islam">Islam</option>
                              <option value="Jainism">Jainism</option>
                              <option value="Juche">Juche</option>
                              <option value="Judaism">Judaism</option>
                              <option value="Neo-Paganism">Neo-Paganism</option>
                              <option value="Nonreligious">Nonreligious</option>
                              <option value="Rastafarianism">Rastafarianism</option>
                              <option value="Secular">Secular</option>
                              <option value="Shinto">Shinto</option>
                              <option value="Sikhism">Sikhism</option>
                              <option value="Spiritism">Spiritism</option>
                              <option value="Tenrikyo">Tenrikyo</option>
                              <option value="Unitarian-Universalism">Unitarian-Universalism</option>
                              <option value="Zoroastrianism">Zoroastrianism</option>
                              <option value="primal-indigenous">primal-indigenous</option>
                              <option value="Other">Other</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-4 mb-3">
                          <div class="">
                            <label for="digit1-input " class="">Patient's Blood group</label>
                            <select class="form-control selectpicker bg-white select-revenue" title="Select Blood Group" data-live-search="true">
                              <option value="A+">A+</option><option value="A-">A-</option>
                              <option value="B+">B+</option><option value="B-">B-</option>
                              <option value="O+">O+</option><option value="O-">O-</option>
                              <option value="AB+">AB+</option><option value="AB-">AB-</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-12 mb-3">
                          <div class="">
                            <label for="digit1-input " class="">Occupation</label>
                            <input type="text " class="form-control two-step " placeholder="Patient's Occupation">
                          </div>
                        </div>

                        <div class="col-12 ">
                          <div class="">
                            <label for="digit1-input " class="">Contact Information</label>
                          </div>
                        </div>

                        <div class="col-12 mb-3">
                          <div class="row">
                            <div class="col-6">
                              <input type="text" class="form-control two-step " placeholder="Phone No">
                            </div>

                            <div class="col-6">
                              <input type="email" class="form-control two-step " placeholder="Email Address">
                            </div>


                          </div>
                        </div>


                        <div class="col-12 ">
                          <div class="">
                            <label for="digit1-input " class="">Patient's Residence</label>
                          </div>
                        </div>

                        <div class="col-12 mb-3">
                          <div class="row">
                            <div class="col-4">
                              <select class="form-control selectpicker bg-white select-revenue" title="Select County" data-live-search="true">
                                <option value="">Busia</option>
                                <option value="">Nairobi</option>
                                <option value="">Homabay</option>
                              </select>
                            </div>

                            <div class="col-4">
                              <select class="form-control selectpicker bg-white select-revenue" title="Select Sub County" data-live-search="true">
                                <option value="">Teso North</option>
                                <option value="">Teso South</option>
                                <option value="">Nambale</option>

                                <option value="">Matayos</option>
                                <option value="">Butula</option>
                                <option value="">Funyula</option>
                                <option value="">Budalangi</option>
                              </select>
                            </div>

                            <div class="col-4">
                              <select class="form-control selectpicker bg-white select-revenue" title="Select Ward" data-live-search="true">
                                <option value="">Marachi West</option>
                                <option value="">Marachi North</option>
                                <option value="">Marachi Central</option>
                                <option value="">Kingandole</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="col-12 mb-3">
                          <div class="">
                            <label for="digit1-input " class="">Physical Address</label>
                            <textarea name="" id=""  class="form-control" placeholder="Enter Address"></textarea>
                          </div>
                        </div>

                      </div>


                    </form>

                  </div>
                </div>
              </div>
              <div class="mb-4 the-step next-of-kin-modal d-none">
                <h4 class="text-primary text-capitalize">Next Of Kin Details</h4>
                <div class="row">

                  <div class="col-12 mb-4">
                    <label for="" class="text-capitalize">Relationship with Patient Being registerd</label>
                    <select class="form-control selectpicker bg-white select-revenue" title="Select Next Of Kin's Relationship with the patient being registered" data-live-search="true">
                      <option value="">Mother</option>
                      <option value="">Father</option>
                      <option value="">Daughter</option>

                      <option value="">Son</option>
                      <option value="">Sister</option>
                      <option value="">Brother</option>

                      <option value="">Friend</option>
                      <option value="">Uncle</option>
                      <option value="">Aunt</option>
                    </select>
                  </div>

                  <div class="col-12 ">
                    <div class="">
                      <label for="digit1-input " class="">Next Of Kin Full Names</label>
                    </div>
                  </div>


                  <div class="col-12 mb-3">
                    <div class="row">
                      <div class="col-4">
                        <input type="text " class="form-control two-step " placeholder="First Name">
                      </div>

                      <div class="col-4">
                        <input type="text " class="form-control two-step " placeholder="Middle Name">
                      </div>

                      <div class="col-4">
                        <input type="text " class="form-control two-step " placeholder="Last Name">
                      </div>
                    </div>
                  </div>

                  <div class="col-12 ">
                    <div class="">
                      <label for="digit1-input " class="">Next Of Kin Contact information</label>
                    </div>
                  </div>


                  <div class="col-12 mb-3">
                    <div class="row">
                      <div class="col-6">
                        <input type="text" class="form-control two-step " placeholder="Phone Number">
                      </div>

                      <div class="col-6">
                        <input type="email" class="form-control two-step " placeholder="Email address">
                      </div>


                    </div>
                  </div>

                  <div class="col-12 mb-3">
                    <div class="">
                      <label for="digit1-input " class="">Physical Address</label>
                      <textarea name="" id=""  class="form-control" placeholder="Enter Address"></textarea>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="modal-footer d-flex">
              <div class="d-none">
                <button data-toggle="modal" data-target="#subscribeModal" data-dismiss="modal" type="button" class="btn btn-link waves-effect">Back To Patient Search</button>
              </div>
              <div class="d-flex modal-next-prev-container">
                <button type="button" class="btn btn-outline-secondary btn-prev waves-effect waves-effect waves-light me-3">
                  <i class="bx bx-left-arrow-alt font-size-16 align-middle me-2"></i> Previouse
                </button>

                <button type="button" class="btn btn-primary waves-effect waves-effect waves-light btn-next">
                  Next <i class="bx bx-right-arrow-alt font-size-16 align-middle me-2"></i>
                </button>

                <button type="button" class="btn btn-submit btn-success d-none ml-3 ms-3 waves-effect waves-effect waves-light btn-next">
                  <i class="bx bx-check-double font-size-16 align-middle me-2"></i> Submit Application
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Patient registration -->

      <footer class="footer ">
        <div class="container-fluid ">
          <div class="row ">
            <div class="col-sm-6 ">

            </div>
            <div class="col-sm-6 ">
              <div class="text-sm-end d-sm-block ">
                2024
              </div>
            </div>
          </div>
        </div>
      </footer>


    </div>
    <!-- end main content-->

  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay "></div>


  </body>


</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import {authUrl, biller, execute, getRight, parking, rent, trade} from "@/api";
export default {
  name: "EmployeeApprovalsEditApprovals",
  components: {NavigationBar},
  data(){
    return{
      alert:{
        success: false,
        info: true,
        failed:false
      },
      currentPage: 1,
      // set the total number of pages as 10 (you can change this according to your data source)
      totalPages: 0,
      // set the number of items per page as 5 (you can change this according to your preference)
      pageSize: 10,
      employeeDataEdits: [],
      message: '',
      selectedEdit: null,
    }
  },
  mounted() {
    this.getEmployeeDataEdits()
  },
  methods:{
    gotTo(route){
      this.$router.push(route);
    },

    // Fetch employee data edits from the server
    getEmployeeDataEdits() {
      const data = new FormData();
      data.append("function", "getEmployeeDataEdits");
      execute(data, authUrl)
          .then((res) => {
            this.employeeDataEdits.splice(0)
            if (res.data.success) {

              this.employeeDataEdits = res.data.data.employeeDataEdits;
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.alert.success = false;
            this.alert.info = false;
            this.alert.failed = true;
            this.message = e.message;
          });
    },

    // View details of a specific edit
    viewEditDetails(item) {
      this.selectedEdit = item;
    },

    // Function to identify changed fields between previousData and newData
    getChangedFields(previousData, newData) {
      try {
        // Parse the JSON strings to objects
        const prevObj = typeof previousData === 'string' ? JSON.parse(previousData) : previousData;
        const newObj = typeof newData === 'string' ? JSON.parse(newData) : newData;

        // List of fields to monitor for changes
        const fieldsToCheck = {
          employeeData: [
            'firstName', 'lastName', 'email', 'phone', 'nationalId', 'title',
            'gender', 'physicalAddress', 'postalCode', 'city', 'country',
            'disabilityStatus', 'disabilityId', 'dob', 'drivingLicense', 'bloodGroup',
            'maritalStatus', 'spouseName'
          ],
          employmentDetails: [
            'departmentID', 'departmentName','section', 'unit', 'subunit', 'designation',
            'employmentDate', 'reportingDate', 'reportingTo', 'netSalary'
          ],
          bankDetails: [
            'accountHolder', 'accountNumber', 'bankCountry', 'bankName',
            'branchLocation', 'shifNumber', 'nssfNumber'
          ]
        };

        // Array to store changed field names
        const changedFields = [];

        // Check primary employeeData fields
        fieldsToCheck.employeeData.forEach(field => {
          if (
              (prevObj.employeeData && newObj.employeeData) &&
              prevObj.employeeData[field] !== newObj.employeeData[field]
          ) {
            changedFields.push(field);
          }
        });

        // Check employment details
        if (prevObj.employmentDetails && newObj.employmentDetails) {
          fieldsToCheck.employmentDetails.forEach(field => {
            const prevValue = prevObj.employmentDetails[field] ||
                (prevObj.employeeData ? prevObj.employeeData[field] : undefined);
            const newValue = newObj.employmentDetails[field] ||
                (newObj.employeeData ? newObj.employeeData[field] : undefined);

            if (prevValue !== newValue && !changedFields.includes(field)) {
              changedFields.push(field);
            }
          });
        }

        // Check bank details
        if (prevObj.bankDetails && newObj.bankDetails) {
          fieldsToCheck.bankDetails.forEach(field => {
            const prevValue = prevObj.bankDetails[field] ||
                (prevObj.employeeData ? prevObj.employeeData[field] : undefined);
            const newValue = newObj.bankDetails[field] ||
                (newObj.employeeData ? newObj.employeeData[field] : undefined);

            if (prevValue !== newValue && !changedFields.includes(field)) {
              changedFields.push(field);
            }
          });
        }

        // Check for changes in emergency contacts
        if (prevObj.emergencyContacts && newObj.emergencyContacts) {
          const emergencyContactsChanged = JSON.stringify(prevObj.emergencyContacts) !==
              JSON.stringify(newObj.emergencyContacts);
          if (emergencyContactsChanged) {
            changedFields.push('emergencyContacts');
          }
        }

        // Check for changes in next of kin
        if (prevObj.nextOfKin && newObj.nextOfKin) {
          const nextOfKinChanged = JSON.stringify(prevObj.nextOfKin) !==
              JSON.stringify(newObj.nextOfKin);
          if (nextOfKinChanged) {
            changedFields.push('nextOfKin');
          }
        }

        // Check for changes in documents
        if (prevObj.documents && newObj.documents) {
          const documentsChanged = JSON.stringify(prevObj.documents) !==
              JSON.stringify(newObj.documents);
          if (documentsChanged) {
            changedFields.push('documents');
          }
        }

        return changedFields;
      } catch (error) {
        console.error("Error comparing data:", error);
        return ["Error processing changes"];
      }
    },

    // Format field names for display
    formatFieldName(fieldName) {
      const specialCases = {
        'dob': 'Date of Birth',
        'nationalId': 'National ID',
        'nextOfKin': 'Next of Kin',
        'emergencyContacts': 'Emergency Contacts',
        'netSalary': 'Net Salary',
        'nssfNumber': 'NSSF Number',
        'shifNumber': 'SHIF Number'
      };

      if (specialCases[fieldName]) {
        return specialCases[fieldName];
      }

      // Add spaces before capital letters and capitalize first letter
      return fieldName
          .replace(/([A-Z])/g, ' $1')
          .replace(/^./, str => str.toUpperCase());
    },

    // Get formatted string of changed fields
    getFormattedChangedFields(previousData, newData) {
      const changedFields = this.getChangedFields(previousData, newData);

      if (changedFields.length === 0) {
        return "No changes detected";
      }

      return changedFields
          .map(field => this.formatFieldName(field))
          .join(', ');
    },

    // Format date for display
    formatDate(dateString) {
      if (!dateString) return '';

      const date = new Date(dateString);
      return date.toLocaleString();
    },

    // Get net salary after the edit
    getNetSalaryAfterEdit(newData) {
      try {
        const newObj = typeof newData === 'string' ? JSON.parse(newData) : newData;

        // Try to get net salary from various locations where it might be stored
        let netSalary = '';

        if (newObj.employeeData && newObj.employeeData.netSalary) {
          netSalary = newObj.employeeData.netSalary;
        } else if (newObj.employmentDetails && newObj.employmentDetails.netSalary) {
          netSalary = newObj.employmentDetails.netSalary;
        } else if (newObj.bankDetails && newObj.bankDetails.netSalary) {
          netSalary = newObj.bankDetails.netSalary;
        }

        // Format netSalary as currency if it's a number
        if (netSalary && !isNaN(netSalary)) {
          return `KES ${parseFloat(netSalary).toLocaleString()}`;
        }

        return netSalary || 'N/A';
      } catch (error) {
        console.error("Error getting net salary:", error);
        return 'N/A';
      }
    },

    // Get detailed changes for display in the modal
    getDetailedChanges(previousData, newData) {
      try {
        // Parse the JSON strings to objects
        const prevObj = typeof previousData === 'string' ? JSON.parse(previousData) : previousData;
        const newObj = typeof newData === 'string' ? JSON.parse(newData) : newData;

        // Track detailed changes with previous and new values
        const detailedChanges = [];

        // Helper function to add a change to the detailedChanges array
        const addChange = (field, displayName, prevValue, newValue) => {
          if (prevValue !== newValue) {
            detailedChanges.push({
              name: field,
              displayName: displayName || this.formatFieldName(field),
              previousValue: prevValue,
              newValue: newValue
            });
          }
        };

        // Structure to define which fields to check and in which objects
        const fieldsToCheck = [
          // Basic employee data
          { section: 'employeeData', fields: [
              { name: 'firstName', display: 'First Name' },
              { name: 'lastName', display: 'Last Name' },
              { name: 'email', display: 'Email' },
              { name: 'phone', display: 'Phone' },
              { name: 'nationalId', display: 'National ID' },
              { name: 'title', display: 'Title' },
              { name: 'gender', display: 'Gender' },
              { name: 'physicalAddress', display: 'Physical Address' },
              { name: 'postalCode', display: 'Postal Code' },
              { name: 'city', display: 'City' },
              { name: 'country', display: 'Country' },
              { name: 'disabilityStatus', display: 'Disability Status' },
              { name: 'disabilityId', display: 'Disability ID' },
              { name: 'dob', display: 'Date of Birth' },
              { name: 'drivingLicense', display: 'Driving License' },
              { name: 'bloodGroup', display: 'Blood Group' },
              { name: 'maritalStatus', display: 'Marital Status' },
              { name: 'spouseName', display: 'Spouse Name' }
            ]},
          // Employment details
          { section: 'employmentDetails', fields: [
              { name: 'departmentName', display: 'departmentName'},
              { name: 'departmentID', display: 'departmentID' },
              { name: 'section', display: 'Section/Sub-vote' },
              { name: 'unit', display: 'Unit/Directorate' },
              { name: 'subunit', display: 'Sub Unit' },
              { name: 'designation', display: 'Designation' },
              { name: 'employmentDate', display: 'Employment Date' },
              { name: 'reportingDate', display: 'Reporting Date' },
              { name: 'reportingTo', display: 'Reporting To' },
              { name: 'netSalary', display: 'Net Salary' }
            ]},
          // Bank details
          { section: 'bankDetails', fields: [
              { name: 'accountHolder', display: 'Account Holder Name' },
              { name: 'accountNumber', display: 'Account Number' },
              { name: 'bankCountry', display: 'Bank Country' },
              { name: 'bankName', display: 'Bank Name' },
              { name: 'branchLocation', display: 'Branch Location' },
              { name: 'shifNumber', display: 'SHIF Number' },
              { name: 'nssfNumber', display: 'NSSF Number' }
            ]}
        ];

        // Process each section and field
        fieldsToCheck.forEach(section => {
          section.fields.forEach(field => {
            let prevValue, newValue;

            // Check if the field exists in the primary section first
            if (prevObj[section.section] && newObj[section.section]) {
              prevValue = prevObj[section.section][field.name];
              newValue = newObj[section.section][field.name];
            }
            // If not found in the section, try to find it in employeeData
            else if (prevObj.employeeData && newObj.employeeData) {
              prevValue = prevObj.employeeData[field.name];
              newValue = newObj.employeeData[field.name];
            }

            // Add the change if values are different
            addChange(field.name, field.display, prevValue, newValue);
          });
        });

        // Handle emergency contacts changes
        if (prevObj.emergencyContacts && newObj.emergencyContacts) {
          // For simplicity, just check if the emergency contacts structure has changed
          const prevEmergencyContacts = JSON.stringify(prevObj.emergencyContacts);
          const newEmergencyContacts = JSON.stringify(newObj.emergencyContacts);

          if (prevEmergencyContacts !== newEmergencyContacts) {
            // Process each emergency contact to show specific changes
            const processedContacts = new Set();

            // Compare emergency contacts with matching IDs
            prevObj.emergencyContacts.forEach(prevContact => {
              const newContact = newObj.emergencyContacts.find(c => c.id === prevContact.id);
              if (newContact) {
                processedContacts.add(prevContact.id);

                // Check for changes in each field
                if (prevContact.name !== newContact.name) {
                  addChange(`emergencyContact_${prevContact.id}_name`,
                      `Emergency Contact: ${prevContact.name}`,
                      prevContact.name,
                      newContact.name);
                }

                if (prevContact.email !== newContact.email) {
                  addChange(`emergencyContact_${prevContact.id}_email`,
                      `Emergency Contact Email (${prevContact.name})`,
                      prevContact.email,
                      newContact.email);
                }

                if (prevContact.phoneNumber !== newContact.phoneNumber) {
                  addChange(`emergencyContact_${prevContact.id}_phone`,
                      `Emergency Contact Phone (${prevContact.name})`,
                      prevContact.phoneNumber,
                      newContact.phoneNumber);
                }

                if (prevContact.relationship !== newContact.relationship) {
                  addChange(`emergencyContact_${prevContact.id}_relationship`,
                      `Emergency Contact Relationship (${prevContact.name})`,
                      prevContact.relationship,
                      newContact.relationship);
                }
              }
            });

            // Add new emergency contacts
            newObj.emergencyContacts.forEach(newContact => {
              if (!prevObj.emergencyContacts.some(c => c.id === newContact.id)) {
                addChange(`emergencyContact_${newContact.id}`,
                    `New Emergency Contact`,
                    'N/A',
                    `${newContact.name} (${newContact.relationship})`);
              }
            });

            // Find removed emergency contacts
            prevObj.emergencyContacts.forEach(prevContact => {
              if (!newObj.emergencyContacts.some(c => c.id === prevContact.id)) {
                addChange(`emergencyContact_${prevContact.id}`,
                    `Removed Emergency Contact`,
                    `${prevContact.name} (${prevContact.relationship})`,
                    'N/A');
              }
            });
          }
        }

        // Handle next of kin changes similarly
        if (prevObj.nextOfKin && newObj.nextOfKin) {
          const prevNextOfKin = JSON.stringify(prevObj.nextOfKin);
          const newNextOfKin = JSON.stringify(newObj.nextOfKin);

          if (prevNextOfKin !== newNextOfKin) {
            // Process individual next of kin changes
            prevObj.nextOfKin.forEach(prevKin => {
              const newKin = newObj.nextOfKin.find(k => k.id === prevKin.id);
              if (newKin) {
                // Check for changes in each field
                if (prevKin.name !== newKin.name) {
                  addChange(`nextOfKin_${prevKin.id}_name`,
                      `Next of Kin: ${prevKin.name}`,
                      prevKin.name,
                      newKin.name);
                }

                if (prevKin.relationship !== newKin.relationship) {
                  addChange(`nextOfKin_${prevKin.id}_relationship`,
                      `Next of Kin Relationship (${prevKin.name})`,
                      prevKin.relationship,
                      newKin.relationship);
                }
              }
            });
          }
        }

        return detailedChanges;
      } catch (error) {
        console.error("Error generating detailed changes:", error);
        return [{ name: 'error', displayName: 'Error', previousValue: 'Error processing changes', newValue: error.message }];
      }
    },

    // Close all modals
    closeAllModals() {
      // Close all modals using Bootstrap's API
      const modals = document.querySelectorAll('.modal.show');
      modals.forEach(modal => {
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) {
          modalInstance.hide();
        }
      });

      // Remove any lingering backdrop elements
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => {
        backdrop.remove();
      });

      // Fix the body by removing modal-open class and inline styles
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');
      document.body.style.removeProperty('overflow');
    },

    // Approve changes
    approveChanges(editId) {
      if (!confirm('Are you sure you want to approve these changes?')) {
        return;
      }



      const data = new FormData();
      data.append("function", "approveEmployeeDataEdit");
      data.append("id", editId);

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {

              this.alert.success = true;
              this.alert.info = false;
              this.alert.failed = false;
              this.getEmployeeDataEdits()
           /*   this.$toast.success("Changes approved successfully");
              // Update the local data to reflect the approval
              const editIndex = this.employeeDataEdits.findIndex(edit => edit.id === editId);
              if (editIndex !== -1) {
                this.employeeDataEdits[editIndex].approved = 'true';
                this.employeeDataEdits[editIndex].approvedBy = this.currentUser;
                this.employeeDataEdits[editIndex].dateApproved = new Date().toISOString();
              }*/
              // Refresh the data

            } else {
              this.alert.success = false;
              this.alert.info = false;
              this.alert.failed = true;
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.$toast.error(e.message || "An error occurred");
          });
    },

    // Decline changes
    declineChanges(editId) {
      if (!confirm('Are you sure you want to decline these changes?')) {
        return;
      }

      const data = new FormData();
      data.append("function", "declineEmployeeDataEdit");
      data.append("id", editId);

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.$toast.success("Changes declined successfully");
              // Update the local data to reflect the decline
              const editIndex = this.employeeDataEdits.findIndex(edit => edit.id === editId);
              if (editIndex !== -1) {
                this.employeeDataEdits[editIndex].approved = 'declined';
              }
              // Refresh the data
              this.getEmployeeDataEdits();
            } else {
              this.$toast.error(res.data.message || "Failed to decline changes");
            }
          })
          .catch((e) => {
            this.$toast.error(e.message || "An error occurred");
          });

  }
}}
</script>

<style scoped>

</style>